<ng-container *transloco="let t; scope: 'scanner'">
  <p *ngIf="!articles?.length">{{ t("scanner.ui-scan-result.not-found") }}</p>

  <app-article-item *ngFor="let article of articles" [article]="article"></app-article-item>
</ng-container>
